import React, { useEffect, useState } from "react";
import { Accordion, Box, Grid, SimpleGrid, Stack, Text } from "@mantine/core";
import { useServicePlanStyles } from "../style";
import ServicePlanAccordion from "../ServicePlanAccordion";
import { IconChevronDown } from "@tabler/icons-react";
import AccordionCheck from "../../AccordionCheck";
import { useMediaQuery } from "@mantine/hooks";
import { useSelector } from "react-redux";
import { getClientTask } from "../../../services/task";
import {
  ADL_ACTIVE_PLAN_TASK_TYPE_ID,
  ADL_TASK_TRIGGER_ID,
} from "../../../pages/Home/Task/AddTask";
// import ServicePlanAccordion from '../ServicePlanAccordion';
// import { useServicePlanStyles } from '../ServicePlanStyles';

export const hiddenFieldsCareplanAdlConfig = {
  Bed: ["Medication"],
  "Skin Care": ["Apply Skin Barrier", "Pedicare"],
};

const ActivitiesOfDailyLivingStep = ({
  data,
  onChange,
  view,
  errors,
  client,
  checks,
  setChecks,
  taskTypeDetails
}) => {
  const { classes } = useServicePlanStyles();
  const isMoobileScreen = useMediaQuery("(max-width: 600px)");
  const isTabletScreen = useMediaQuery("(max-width: 1030px)");
  const { profile } = useSelector((state) => state.profile);
  let userType = profile?.user?.type;

  const handleAccordionChange = (section, items) => {
    onChange({
      ...data,
      [section]: items,
    });
  };

  useEffect(() => {
    if (data?.fieldsDone && data.fieldsDone.length > 0 && checks.length === 0) {
      setChecks(data.fieldsDone);
    }
  }, [data?.fieldsDone]);

  const brushingTeeth = [
    {
      name: "Independent with Setup",

      subItems: [{ name: "Daily" }, { name: "PRN" }, { name: "Reminder" }],
    },
    {
      name: "Dependent",

      subItems: [{ name: "Daily" }, { name: "PRN" }, { name: "Picking Out" }],
    },
    {
      name: "Dentures",

      subItems: [{ name: "Full" }, { name: "Upper" }, { name: "Lower" }],
    },
    { name: "Brush and soak dentures overnight" },
    { name: "Resident does not remove dentures" },
    { name: "No teeth swab gums" },
  ];

  // BED CHECK
  const bedCheck = [
    {
      name: "Make Bed",

      subItems: [{ name: "Independent" }, { name: "Dependent" }],
    },
    {
      name: "Change Linen 1/Week (PRN)",

      subItems: [{ name: "Independent" }, { name: "Dependent" }],
    },
    {
      name: "Diabetic Check",

      subItems: [
        { name: "Bruises/Cuts, Color, Temperature of feet" },
        { name: "Toe Nails/Finger Nails" },
        { name: "Podiatrist for a fee" },
        { name: "Bed Positioning" },
        { name: "Call Light Access Check" },
        { name: "Room Safety Tidy" },
        { name: "Night Check or Bed Check" },
      ],
    },
  ];

  // SKIN CARE
  const skinCare = [
    { name: "PRN Lotion" },
    { name: "Monitor Skin Integrity" },
    { name: "Monitor Boney Areas" },
    { name: "Apply cream/ointment as Prescribed" },
    { name: "Maintain good nutrition and fluid intake" },
    {
      name: "Perineal care as needed with every brief change",
    },
    { name: "Pressure relieving device PRN" },
    { name: "Float Heals PRN" },
  ];

  // NUTRITION AND HYDRATION
  const nutritionAndHydration = [
    { name: "Breakfast Assistance" },
    { name: "Lunch Assistance" },
    { name: "Dinner Assistance" },
    { name: "Snack Assistance" },
    { name: "Water or Hydration Support" },
    { name: "Feeding Assistance" },
    { name: "Meal Setup" },
    { name: "Cueing to Eat" },
    { name: "Monitor Intake" },
  ];

  // TOILETING
  const toileting = [
    {
      name: "Independent",

      subItems: [{ name: "Reminder - Q2H" }],
    },
    {
      name: "Dependent",

      subItems: [{ name: "1-2 CG" }],
    },
    {
      name: "Continent",

      subItems: [{ name: "Bladder" }, { name: "Bowel" }],
    },
    {
      name: "Incontinent",

      subItems: [
        { name: "Bladder" },
        { name: "Bowel" },
        { name: "Mixed Incontinence" },
      ],
    },
    {
      name: "Accidents",

      subItems: [
        { name: "Bladder" },
        { name: "Bowel" },
        { name: "Night Incontinence" },
      ],
    },
    {
      name: "Foley Cather",

      subItems: [{ name: "Change" }, { name: "Empty PRN" }],
    },
    {
      name: "Colostomy",

      subItems: [{ name: "Change" }, { name: "Empty PRN" }],
    },
  ];

  // UNDERGARMENTS
  const undergarments = [
    { name: "Underwear", hasTextInput: true },
    {
      name: "Independent",

      subItems: [
        { name: "Pull-ups" },
        { name: "Tape Briefs" },
        { name: "Pad" },
      ],
    },
    {
      name: "Dependent",

      subItems: [
        { name: "Pull-ups" },
        { name: "Tape Briefs" },
        { name: "Pad" },
      ],
    },
    { name: "Change Brief - Q2-3 Hrs" },
    { name: "Change Brief PRN" },
  ];

  // DRESSING
  const dressing = [
    {
      name: "Independent",

      subItems: [
        { name: "Clothing" },
        { name: "Socks/Shoes" },
        { name: "Picking Out" },
      ],
    },
    {
      name: "Partial Assistance",

      subItems: [
        { name: "Clothing" },
        { name: "Socks/Shoes" },
        { name: "Picking Out" },
      ],
    },
    {
      name: "Full Assistance",

      subItems: [
        { name: "Clothing" },
        { name: "Socks/Shoes" },
        { name: "Picking Out" },
      ],
    },
  ];

  // GROOMING
  const grooming = [
    {
      name: "Independent",

      subItems: [
        { name: "Comb hair" },
        { name: "Daily" },
        { name: "Reminder" },
      ],
    },
    {
      name: "Dependent",

      subItems: [{ name: "Comb hair" }, { name: "Daily" }],
    },
    { name: "Manicure/Pedicure" },
  ];

  // VITAL SIGNS AND HEALTH MONITORING
  const vitalSignsAndHealthMonitoring = [
    {
      name: "Weight",
    },
    {
      name: "Temperature",
    },
    {
      name: "Pulse",
    },
    { name: "Respiration" },
    { name: "Blood Pressure" },
    { name: "Oxygen Saturation" },
    { name: "Blood Sugar Check" },
    { name: "Pain Assessment" },
    { name: "Intake and Output Monitoring" },
  ];

  // SHOWER
  const shower = [
    { name: "How many showers weekly?", hasTextInput: true },
    { name: "Shampoo/conditioner" },
    { name: "Body Wash" },
    { name: "Partial Bath PRN" },
    { name: "Full Bed Bath" },
    { name: "Shave PRN" },
  ];

  // OTHER
  const other = [
    { name: "Snack and Water Rounds" },
    { name: "Family Communication Support" },
    { name: "Mood Observation" },
  ];

  return (
    <Box className={classes.formSection}>
      <Accordion
        className={classes.accordionStyle}
        chevron={<IconChevronDown />}
        chevronPosition="right"
        chevronSize={20}
        variant="separated"
        defaultValue="activitiesOfDailyLiving"
      >
        <Accordion.Item value="activitiesOfDailyLiving">
          <Accordion.Control>Activities of Daily Living</Accordion.Control>
          <Accordion.Panel>
            <SimpleGrid cols={isMoobileScreen ? 1 : isTabletScreen ? 2 : 4}>
              {taskTypeDetails?.subTasks
                ?.filter(
                  (tasks) =>
                    tasks?.task?.name !== "Meals" &&
                    tasks?.task?.name !== "Body Care",
                )
                ?.map((tasks) => {
                  const subTaskName = tasks?.task?.name;
                  const hiddenFields = hiddenFieldsCareplanAdlConfig[subTaskName] || [];
                  const filteredFields =
                    tasks?.fields?.filter(
                      (field) => !hiddenFields.includes(field?.name),
                    ) || [];

                  return (
                    <div key={tasks?._id}>
                      <AccordionCheck
                        type={view === true ? "view" : "add"}
                        data-testid="task-grid"
                        tasks={tasks}
                        Data={filteredFields}
                        Heading={tasks?.task?.name}
                        setChecks={setChecks}
                        checks={checks}
                        userType={userType}
                        userId={profile?.user?.id}
                        // shift={profile?.user?.id}
                        shift={""}
                        profile={profile}
                        selectedStaff={profile?.user?.id}
                        selectedStaffData={profile?.user}
                        // requiredCheckedFields={requiredCheckedFields}
                        isFromServicePlan={true}
                      />
                    </div>
                  );
                })}
            </SimpleGrid>
            {/* <Grid>
              <Grid.Col span={4}>
                <ServicePlanAccordion
                  title="Brushing Teeth"
                  items={brushingTeeth}
                  selectedItems={data?.brushingTeeth || []}
                  onChange={(items) =>
                    handleAccordionChange("brushingTeeth", items)
                  }
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <ServicePlanAccordion
                  title="Bed Check"
                  items={bedCheck}
                  selectedItems={data?.bedCheck || []}
                  onChange={(items) => handleAccordionChange("bedCheck", items)}
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <ServicePlanAccordion
                  title="Skin Care"
                  items={skinCare}
                  selectedItems={data?.skinCare || []}
                  onChange={(items) => handleAccordionChange("skinCare", items)}
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <ServicePlanAccordion
                  title="Nutrition and Hydration"
                  items={nutritionAndHydration}
                  selectedItems={data?.nutritionAndHydration || []}
                  onChange={(items) =>
                    handleAccordionChange("nutritionAndHydration", items)
                  }
                  view={view}
                />
              </Grid.Col>

              <Grid.Col span={4}>
                <ServicePlanAccordion
                  title="Toileting"
                  items={toileting}
                  selectedItems={data?.toileting || []}
                  onChange={(items) =>
                    handleAccordionChange("toileting", items)
                  }
                  view={view}
                />
              </Grid.Col>

              <Grid.Col span={4}>
                <ServicePlanAccordion
                  title="Undergarments"
                  items={undergarments}
                  selectedItems={data?.undergarments || []}
                  onChange={(items) =>
                    handleAccordionChange("undergarments", items)
                  }
                  view={view}
                />
              </Grid.Col>

              <Grid.Col span={4}>
                <ServicePlanAccordion
                  title="Dressing"
                  items={dressing}
                  selectedItems={data?.dressing || []}
                  onChange={(items) => handleAccordionChange("dressing", items)}
                  view={view}
                />
              </Grid.Col>

              <Grid.Col span={4}>
                <ServicePlanAccordion
                  title="Grooming"
                  items={grooming}
                  selectedItems={data?.grooming || []}
                  onChange={(items) => handleAccordionChange("grooming", items)}
                  view={view}
                />
              </Grid.Col>

              <Grid.Col span={4}>
                <ServicePlanAccordion
                  title="Vital Signs and Health Monitoring"
                  items={vitalSignsAndHealthMonitoring}
                  selectedItems={data?.vitalSignsAndHealthMonitoring || []}
                  onChange={(items) =>
                    handleAccordionChange(
                      "vitalSignsAndHealthMonitoring",
                      items,
                    )
                  }
                  view={view}
                />
              </Grid.Col>

              <Grid.Col span={4}>
                <ServicePlanAccordion
                  title="Shower"
                  items={shower}
                  selectedItems={data?.shower || []}
                  onChange={(items) => handleAccordionChange("shower", items)}
                  view={view}
                />
              </Grid.Col>

              <Grid.Col span={4}>
                <ServicePlanAccordion
                  title="Other"
                  items={other}
                  selectedItems={data?.other || []}
                  onChange={(items) => handleAccordionChange("other", items)}
                  view={view}
                />
              </Grid.Col>
            </Grid> */}
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Box>
  );
};

export default ActivitiesOfDailyLivingStep;
